module.exports = __webpack_public_path__ + "img/home-predict-icon-red.477d3ca5.png";